import { useEffect, useState } from "react";
import { useT } from "./i18n";

/**
 * "Loading…" that does not leave the member stuck (review, 4b step 3b): after 10 seconds it says
 * so and offers to try again, which reloads the page.
 */
export function Loading({ className = "muted center" }: { className?: string }) {
  const t = useT();
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), 10_000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className={className}>
      <p>{t.common.loading}</p>
      {slow && (
        <p className="small">
          {t.common.loadingSlow}{" "}
          <button type="button" onClick={() => location.reload()}>
            {t.common.tryAgain}
          </button>
        </p>
      )}
    </div>
  );
}

/** A failure that a reload may fix (server unreachable), with the way out. */
export function Failed({ text }: { text: string }) {
  const t = useT();
  return (
    <div className="center">
      <p className="error">{text}</p>
      <button type="button" onClick={() => location.reload()}>
        {t.common.tryAgain}
      </button>
    </div>
  );
}
